// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateIntegrationConfigurationMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateIntegrationConfigurationInput;
}>;


export type UpdateIntegrationConfigurationMutation = { __typename?: 'Mutation', updateIntegrationConfiguration?: (
    { __typename?: 'IntegrationConfiguration' }
    & AdminIntegrationsPage_IntegrationConfigurationFragment
  ) | null };

export type SyncSnowflakeAssetsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SyncSnowflakeAssetsMutation = { __typename?: 'Mutation', syncSnowflakeAssets: string };

export type SyncSnowflakeHouseholdsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SyncSnowflakeHouseholdsMutation = { __typename?: 'Mutation', syncSnowflakeHouseholds: string };

export type CreateOpenaiSdkConfigMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateOpenaiSdkConfigInput;
}>;


export type CreateOpenaiSdkConfigMutation = { __typename?: 'Mutation', createOpenaiSdkConfig: (
    { __typename?: 'OpenaiSdkConfig' }
    & AzureByokIntegrationCard_OpenaiSdkConfigFragment
    & OpenAiIntegrationCard_OpenaiSdkConfigFragment
  ) };

export type UpdateOpenaiSdkConfigMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateOpenaiSdkConfigInput;
}>;


export type UpdateOpenaiSdkConfigMutation = { __typename?: 'Mutation', updateOpenaiSdkConfig: (
    { __typename?: 'OpenaiSdkConfig' }
    & AzureByokIntegrationCard_OpenaiSdkConfigFragment
    & OpenAiIntegrationCard_OpenaiSdkConfigFragment
  ) };

export type AdminIntegrationsPage_IntegrationConfigurationFragment = { __typename?: 'IntegrationConfiguration', id: string, addeparSubdomain?: string | null, addeparFirmID?: string | null, addeparClientType: Types.IntegrationConfigurationAddeparClientType, addeparLookThroughCompositeSecurities: boolean, addeparCustomAssetClassName?: string | null, addeparCustomAssetNameAPIField?: string | null, addeparEnableHouseholdSummarySync: boolean, orionEnabled: boolean, updatedAt: Time, blackDiamondEnabled: boolean, emoneyEnabled: boolean, snowflakeDataSharingEnabled: boolean, snowflakeHouseholdSyncEnabled: boolean, integrationUserEnabled: boolean, enableLlmByok: boolean };

export type SyncAddeparHouseholdSummaryMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type SyncAddeparHouseholdSummaryMutation = { __typename?: 'Mutation', syncAddeparHouseholdSummary: boolean };

export type GetIntegrationConfigurationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetIntegrationConfigurationQuery = { __typename?: 'Query', integrationConfiguration?: (
    { __typename?: 'IntegrationConfiguration' }
    & AdminIntegrationsPage_IntegrationConfigurationFragment
  ) | null, isIntegrationUserLoggedInToAddepar: { __typename?: 'IsLoggedInToAddepar', isLoggedIn: boolean, isTokenValid: boolean, externalUserName?: string | null }, isIntegrationUserLoggedInToBlackDiamond: { __typename?: 'IsLoggedIn', isLoggedIn: boolean, isTokenValid: boolean, externalUserName?: string | null }, isIntegrationUserLoggedInToOrion: { __typename?: 'IsLoggedIn', isLoggedIn: boolean, isTokenValid: boolean, externalUserName?: string | null }, isIntegrationUserLoggedInToEMoney: { __typename?: 'IsLoggedIn', isLoggedIn: boolean, isTokenValid: boolean, externalUserName?: string | null }, openaiSdkConfigs: { __typename?: 'OpenaiSdkConfigConnection', edges?: Array<{ __typename?: 'OpenaiSdkConfigEdge', node?: (
        { __typename?: 'OpenaiSdkConfig' }
        & AzureByokIntegrationCard_OpenaiSdkConfigFragment
      ) | null } | null> | null }, openaiSdkConfigsForOpenAI: { __typename?: 'OpenaiSdkConfigConnection', edges?: Array<{ __typename?: 'OpenaiSdkConfigEdge', node?: (
        { __typename?: 'OpenaiSdkConfig' }
        & OpenAiIntegrationCard_OpenaiSdkConfigFragment
      ) | null } | null> | null } };

export type AzureByokIntegrationCard_OpenaiSdkConfigFragment = { __typename?: 'OpenaiSdkConfig', id: string, baseURL?: string | null, provider: Types.OpenaiSdkConfigProvider, enabled: boolean, modelMappings: { __typename?: 'ModelMappingConnection', edges?: Array<{ __typename?: 'ModelMappingEdge', node?: { __typename?: 'ModelMapping', id: string, modelName: string, modelPurpose: Types.ModelMappingModelPurpose } | null } | null> | null } };

export type OpenAiIntegrationCard_OpenaiSdkConfigFragment = { __typename?: 'OpenaiSdkConfig', id: string, provider: Types.OpenaiSdkConfigProvider, baseURL?: string | null, enabled: boolean };

export const Operations = {
  Query: {
    GetIntegrationConfiguration: 'GetIntegrationConfiguration' as const
  },
  Mutation: {
    UpdateIntegrationConfiguration: 'UpdateIntegrationConfiguration' as const,
    SyncSnowflakeAssets: 'SyncSnowflakeAssets' as const,
    SyncSnowflakeHouseholds: 'SyncSnowflakeHouseholds' as const,
    CreateOpenaiSdkConfig: 'CreateOpenaiSdkConfig' as const,
    UpdateOpenaiSdkConfig: 'UpdateOpenaiSdkConfig' as const,
    SyncAddeparHouseholdSummary: 'SyncAddeparHouseholdSummary' as const
  },
  Fragment: {
    AdminIntegrationsPage_IntegrationConfiguration: 'AdminIntegrationsPage_IntegrationConfiguration' as const,
    AzureBYOKIntegrationCard_OpenaiSdkConfig: 'AzureBYOKIntegrationCard_OpenaiSdkConfig' as const,
    OpenAIIntegrationCard_OpenaiSdkConfig: 'OpenAIIntegrationCard_OpenaiSdkConfig' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AdminIntegrationsPage_IntegrationConfigurationFragmentDoc = gql`
    fragment AdminIntegrationsPage_IntegrationConfiguration on IntegrationConfiguration {
  id
  addeparSubdomain
  addeparFirmID
  addeparClientType
  addeparLookThroughCompositeSecurities
  addeparCustomAssetClassName
  addeparCustomAssetNameAPIField
  addeparEnableHouseholdSummarySync
  orionEnabled
  updatedAt
  blackDiamondEnabled
  emoneyEnabled
  snowflakeDataSharingEnabled
  snowflakeHouseholdSyncEnabled
  integrationUserEnabled
  enableLlmByok
}
    `;
export const AzureByokIntegrationCard_OpenaiSdkConfigFragmentDoc = gql`
    fragment AzureBYOKIntegrationCard_OpenaiSdkConfig on OpenaiSdkConfig {
  id
  baseURL
  provider
  enabled
  modelMappings {
    edges {
      node {
        id
        modelName
        modelPurpose
      }
    }
  }
}
    `;
export const OpenAiIntegrationCard_OpenaiSdkConfigFragmentDoc = gql`
    fragment OpenAIIntegrationCard_OpenaiSdkConfig on OpenaiSdkConfig {
  id
  provider
  baseURL
  enabled
}
    `;
export const UpdateIntegrationConfigurationDocument = gql`
    mutation UpdateIntegrationConfiguration($input: AugmentedUpdateIntegrationConfigurationInput!) {
  updateIntegrationConfiguration(input: $input) {
    ...AdminIntegrationsPage_IntegrationConfiguration
  }
}
    ${AdminIntegrationsPage_IntegrationConfigurationFragmentDoc}`;
export type UpdateIntegrationConfigurationMutationFn = Apollo.MutationFunction<UpdateIntegrationConfigurationMutation, UpdateIntegrationConfigurationMutationVariables>;

/**
 * __useUpdateIntegrationConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationConfigurationMutation, { data, loading, error }] = useUpdateIntegrationConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntegrationConfigurationMutation, UpdateIntegrationConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntegrationConfigurationMutation, UpdateIntegrationConfigurationMutationVariables>(UpdateIntegrationConfigurationDocument, options);
      }
export type UpdateIntegrationConfigurationMutationHookResult = ReturnType<typeof useUpdateIntegrationConfigurationMutation>;
export type UpdateIntegrationConfigurationMutationResult = Apollo.MutationResult<UpdateIntegrationConfigurationMutation>;
export type UpdateIntegrationConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateIntegrationConfigurationMutation, UpdateIntegrationConfigurationMutationVariables>;
export const SyncSnowflakeAssetsDocument = gql`
    mutation SyncSnowflakeAssets {
  syncSnowflakeAssets
}
    `;
export type SyncSnowflakeAssetsMutationFn = Apollo.MutationFunction<SyncSnowflakeAssetsMutation, SyncSnowflakeAssetsMutationVariables>;

/**
 * __useSyncSnowflakeAssetsMutation__
 *
 * To run a mutation, you first call `useSyncSnowflakeAssetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncSnowflakeAssetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncSnowflakeAssetsMutation, { data, loading, error }] = useSyncSnowflakeAssetsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncSnowflakeAssetsMutation(baseOptions?: Apollo.MutationHookOptions<SyncSnowflakeAssetsMutation, SyncSnowflakeAssetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncSnowflakeAssetsMutation, SyncSnowflakeAssetsMutationVariables>(SyncSnowflakeAssetsDocument, options);
      }
export type SyncSnowflakeAssetsMutationHookResult = ReturnType<typeof useSyncSnowflakeAssetsMutation>;
export type SyncSnowflakeAssetsMutationResult = Apollo.MutationResult<SyncSnowflakeAssetsMutation>;
export type SyncSnowflakeAssetsMutationOptions = Apollo.BaseMutationOptions<SyncSnowflakeAssetsMutation, SyncSnowflakeAssetsMutationVariables>;
export const SyncSnowflakeHouseholdsDocument = gql`
    mutation SyncSnowflakeHouseholds {
  syncSnowflakeHouseholds
}
    `;
export type SyncSnowflakeHouseholdsMutationFn = Apollo.MutationFunction<SyncSnowflakeHouseholdsMutation, SyncSnowflakeHouseholdsMutationVariables>;

/**
 * __useSyncSnowflakeHouseholdsMutation__
 *
 * To run a mutation, you first call `useSyncSnowflakeHouseholdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncSnowflakeHouseholdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncSnowflakeHouseholdsMutation, { data, loading, error }] = useSyncSnowflakeHouseholdsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncSnowflakeHouseholdsMutation(baseOptions?: Apollo.MutationHookOptions<SyncSnowflakeHouseholdsMutation, SyncSnowflakeHouseholdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncSnowflakeHouseholdsMutation, SyncSnowflakeHouseholdsMutationVariables>(SyncSnowflakeHouseholdsDocument, options);
      }
export type SyncSnowflakeHouseholdsMutationHookResult = ReturnType<typeof useSyncSnowflakeHouseholdsMutation>;
export type SyncSnowflakeHouseholdsMutationResult = Apollo.MutationResult<SyncSnowflakeHouseholdsMutation>;
export type SyncSnowflakeHouseholdsMutationOptions = Apollo.BaseMutationOptions<SyncSnowflakeHouseholdsMutation, SyncSnowflakeHouseholdsMutationVariables>;
export const CreateOpenaiSdkConfigDocument = gql`
    mutation CreateOpenaiSdkConfig($input: AugmentedCreateOpenaiSdkConfigInput!) {
  createOpenaiSdkConfig(input: $input) {
    ...AzureBYOKIntegrationCard_OpenaiSdkConfig
    ...OpenAIIntegrationCard_OpenaiSdkConfig
  }
}
    ${AzureByokIntegrationCard_OpenaiSdkConfigFragmentDoc}
${OpenAiIntegrationCard_OpenaiSdkConfigFragmentDoc}`;
export type CreateOpenaiSdkConfigMutationFn = Apollo.MutationFunction<CreateOpenaiSdkConfigMutation, CreateOpenaiSdkConfigMutationVariables>;

/**
 * __useCreateOpenaiSdkConfigMutation__
 *
 * To run a mutation, you first call `useCreateOpenaiSdkConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOpenaiSdkConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOpenaiSdkConfigMutation, { data, loading, error }] = useCreateOpenaiSdkConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOpenaiSdkConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateOpenaiSdkConfigMutation, CreateOpenaiSdkConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOpenaiSdkConfigMutation, CreateOpenaiSdkConfigMutationVariables>(CreateOpenaiSdkConfigDocument, options);
      }
export type CreateOpenaiSdkConfigMutationHookResult = ReturnType<typeof useCreateOpenaiSdkConfigMutation>;
export type CreateOpenaiSdkConfigMutationResult = Apollo.MutationResult<CreateOpenaiSdkConfigMutation>;
export type CreateOpenaiSdkConfigMutationOptions = Apollo.BaseMutationOptions<CreateOpenaiSdkConfigMutation, CreateOpenaiSdkConfigMutationVariables>;
export const UpdateOpenaiSdkConfigDocument = gql`
    mutation UpdateOpenaiSdkConfig($input: AugmentedUpdateOpenaiSdkConfigInput!) {
  updateOpenaiSdkConfig(input: $input) {
    ...AzureBYOKIntegrationCard_OpenaiSdkConfig
    ...OpenAIIntegrationCard_OpenaiSdkConfig
  }
}
    ${AzureByokIntegrationCard_OpenaiSdkConfigFragmentDoc}
${OpenAiIntegrationCard_OpenaiSdkConfigFragmentDoc}`;
export type UpdateOpenaiSdkConfigMutationFn = Apollo.MutationFunction<UpdateOpenaiSdkConfigMutation, UpdateOpenaiSdkConfigMutationVariables>;

/**
 * __useUpdateOpenaiSdkConfigMutation__
 *
 * To run a mutation, you first call `useUpdateOpenaiSdkConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOpenaiSdkConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOpenaiSdkConfigMutation, { data, loading, error }] = useUpdateOpenaiSdkConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOpenaiSdkConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOpenaiSdkConfigMutation, UpdateOpenaiSdkConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOpenaiSdkConfigMutation, UpdateOpenaiSdkConfigMutationVariables>(UpdateOpenaiSdkConfigDocument, options);
      }
export type UpdateOpenaiSdkConfigMutationHookResult = ReturnType<typeof useUpdateOpenaiSdkConfigMutation>;
export type UpdateOpenaiSdkConfigMutationResult = Apollo.MutationResult<UpdateOpenaiSdkConfigMutation>;
export type UpdateOpenaiSdkConfigMutationOptions = Apollo.BaseMutationOptions<UpdateOpenaiSdkConfigMutation, UpdateOpenaiSdkConfigMutationVariables>;
export const SyncAddeparHouseholdSummaryDocument = gql`
    mutation SyncAddeparHouseholdSummary {
  syncAddeparHouseholdSummary
}
    `;
export type SyncAddeparHouseholdSummaryMutationFn = Apollo.MutationFunction<SyncAddeparHouseholdSummaryMutation, SyncAddeparHouseholdSummaryMutationVariables>;

/**
 * __useSyncAddeparHouseholdSummaryMutation__
 *
 * To run a mutation, you first call `useSyncAddeparHouseholdSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncAddeparHouseholdSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncAddeparHouseholdSummaryMutation, { data, loading, error }] = useSyncAddeparHouseholdSummaryMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncAddeparHouseholdSummaryMutation(baseOptions?: Apollo.MutationHookOptions<SyncAddeparHouseholdSummaryMutation, SyncAddeparHouseholdSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncAddeparHouseholdSummaryMutation, SyncAddeparHouseholdSummaryMutationVariables>(SyncAddeparHouseholdSummaryDocument, options);
      }
export type SyncAddeparHouseholdSummaryMutationHookResult = ReturnType<typeof useSyncAddeparHouseholdSummaryMutation>;
export type SyncAddeparHouseholdSummaryMutationResult = Apollo.MutationResult<SyncAddeparHouseholdSummaryMutation>;
export type SyncAddeparHouseholdSummaryMutationOptions = Apollo.BaseMutationOptions<SyncAddeparHouseholdSummaryMutation, SyncAddeparHouseholdSummaryMutationVariables>;
export const GetIntegrationConfigurationDocument = gql`
    query GetIntegrationConfiguration {
  integrationConfiguration {
    ...AdminIntegrationsPage_IntegrationConfiguration
  }
  isIntegrationUserLoggedInToAddepar {
    isLoggedIn
    isTokenValid
    externalUserName
  }
  isIntegrationUserLoggedInToBlackDiamond {
    isLoggedIn
    isTokenValid
    externalUserName
  }
  isIntegrationUserLoggedInToOrion {
    isLoggedIn
    isTokenValid
    externalUserName
  }
  isIntegrationUserLoggedInToEMoney {
    isLoggedIn
    isTokenValid
    externalUserName
  }
  openaiSdkConfigs(where: {provider: AZURE}) {
    edges {
      node {
        ...AzureBYOKIntegrationCard_OpenaiSdkConfig
      }
    }
  }
  openaiSdkConfigsForOpenAI: openaiSdkConfigs(where: {provider: OPENAI}) {
    edges {
      node {
        ...OpenAIIntegrationCard_OpenaiSdkConfig
      }
    }
  }
}
    ${AdminIntegrationsPage_IntegrationConfigurationFragmentDoc}
${AzureByokIntegrationCard_OpenaiSdkConfigFragmentDoc}
${OpenAiIntegrationCard_OpenaiSdkConfigFragmentDoc}`;

/**
 * __useGetIntegrationConfigurationQuery__
 *
 * To run a query within a React component, call `useGetIntegrationConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GetIntegrationConfigurationQuery, GetIntegrationConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationConfigurationQuery, GetIntegrationConfigurationQueryVariables>(GetIntegrationConfigurationDocument, withFetchPolicyContext(options));
      }
export function useGetIntegrationConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationConfigurationQuery, GetIntegrationConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationConfigurationQuery, GetIntegrationConfigurationQueryVariables>(GetIntegrationConfigurationDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetIntegrationConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationConfigurationQuery, GetIntegrationConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationConfigurationQuery, GetIntegrationConfigurationQueryVariables>(GetIntegrationConfigurationDocument, withFetchPolicyContext(options));
        }
export type GetIntegrationConfigurationQueryHookResult = ReturnType<typeof useGetIntegrationConfigurationQuery>;
export type GetIntegrationConfigurationLazyQueryHookResult = ReturnType<typeof useGetIntegrationConfigurationLazyQuery>;
export type GetIntegrationConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationConfigurationSuspenseQuery>;
export type GetIntegrationConfigurationQueryResult = Apollo.QueryResult<GetIntegrationConfigurationQuery, GetIntegrationConfigurationQueryVariables>;